import React, { useEffect, useRef, useState } from "react";
import MentoriaQuestion from "../mentoria-question/mentoriaQuestion";
import "./mentoriaQuestionWizard.scss";
import Button from "../../../atoms/button/button";
import ProgressBar from "../../../atoms/progress-bar-mentoria/progressBarMentoria";
import { IQuestion } from "../interfaces";

interface mentoriaQuestionWizard {
   questions: Array<IQuestion>;
   formData: any;
   setData: any;
   onMovePreviousFallback: any;
   onMoveAfterFallback: any
   blobImage?: string;
   setHeaderStep?: any;
}

const MentoriaQuestionWizard = (props: mentoriaQuestionWizard) => {
   const {
      questions,
      formData,
      setData,
      onMoveAfterFallback,
      onMovePreviousFallback,
      blobImage = "",
      setHeaderStep = () => { }
   } = props;

   const [questionCounter, setQuestionCounter] = useState(0);
   const [shouldDisplay, setShouldDisplay] = useState(false);
   const [error, setError] = useState({ message: "" });
   const [currentQuestion, setCurrentQuestion] = useState(questions[questionCounter]);
   const [moveBack, setMoveBack] = useState(false);
   const [isDisabled, setIsDisabled] = useState(false);
   const headerRef: any = useRef(null);

   useEffect(() => {
      setShouldDisplay(false);

      if (questionCounter >= questions.length) {
         props.onMoveAfterFallback();
         return;
      }

      if (questions[questionCounter].preRequisiteQuestions) {
         const found = questions.find((question) => {
            if (question.id === questions[questionCounter].preRequisiteQuestions?.idQuestion) {
               if (questions[questionCounter].preRequisiteQuestions?.options.find((option => option.id === (formData[question.id].id)))) {
                  return question;
               }
            }
            return undefined;
         });
         if (!found) {
            if (moveBack) {
               setQuestionCounter(questionCounter - 1);
            } else {
               setQuestionCounter(questionCounter + 1);
            }
         }
      }
      setCurrentQuestion(questions[questionCounter]);
      setShouldDisplay(true);

   }, [questionCounter]);

   useEffect(() => {
      if (currentQuestion.required) {
         if (formData[currentQuestion.id] === 0) {
            setIsDisabled(false);
         } else {
            setIsDisabled(formData[currentQuestion.id] ? false : true);
         }
      } else {
         setIsDisabled(false);
      }
   }, [formData[currentQuestion.id]])


   const movePreviousQuestion = () => {
      setError({ message: "" });
      setMoveBack(true);
      if (questionCounter - 1 < 0) {
         onMovePreviousFallback();
      } else {
         setQuestionCounter(questionCounter - 1);
      }
   };

   const moveNextQuestion = () => {
      setError({ message: "" });
      setMoveBack(false);

      if (questions[questionCounter].required) {
         if ((!formData[questions[questionCounter].id] && formData[questions[questionCounter].id] !== 0) ||
            Array.isArray(formData[questions[questionCounter].id] && !formData[questions[questionCounter].id].length)) {
            setError({ message: "Debes responder antes de continuar" });
            return;
         }
      }
      if (questionCounter + 1 >= questions.length) {
         onMoveAfterFallback();
         return;
      }
      setQuestionCounter(questionCounter + 1);
      setHeaderStep(questions[questionCounter].purpose)
   };

   // useEffect(() => {
   //    if (headerRef && headerRef.current) {
   //       const y = headerRef.current.getBoundingClientRect().top + window.pageYOffset - 70;
   //       window.scrollTo({
   //          top: y
   //       });
   //    }
   // }, [questionCounter])


   // 42 

   return (
      <div className="o-mentoriaQuestionWizard-container">
         <ProgressBar percentage={Math.round((questionCounter * 100) / questions.length)} onClick={movePreviousQuestion} />
         <div className="o-mentoriaQuestionWizard-container__back-button" onClick={movePreviousQuestion}>
            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="currentColor" viewBox="0 0 16 16">
               <path fillRule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z" />
            </svg>
         </div>
         {shouldDisplay && <>
            <div ref={headerRef}>
               {currentQuestion &&
                  <MentoriaQuestion
                     question={currentQuestion}
                     value={formData[currentQuestion.id]}
                     movePreviousQuestion={movePreviousQuestion}
                     moveNextQuestion={moveNextQuestion}
                     setData={setData}
                     formData={formData}
                     error={error}
                     parentId={currentQuestion.id}
                     blobImage={blobImage}
                  />
               }
            </div>
            {error.message && <p className="o-mentoriaQuestionWizard-container__error-message">{error.message}</p>}
            <div className="o-mentoriaQuestionWizard-container__buttons-container">
               {questionCounter > 0 &&
                  <Button
                     type="button"
                     classname="o-mentoriaQuestionWizard-container__buttons-container__button"
                     text="Volver"
                     isDisabled={/*currentQuestion.prev ? */false /*: true*/}
                     onClickAction={movePreviousQuestion}
                     gtmMark="primary"
                  />
               }
               <Button
                  type="button"
                  classname="o-mentoriaQuestionWizard-container__buttons-container__button"
                  text={/*(currentQuestion && currentQuestion.next && currentQuestion.next.value) ? "Continuar" : "Finalizar"*/ 'Continuar'}
                  isDisabled={isDisabled}
                  onClickAction={moveNextQuestion}
               />
            </div>
         </>}
      </div>
   );
};

export default MentoriaQuestionWizard;
